<template>
  <Component :is="pageComponent" :article="article" />
</template>

<script>
import LayoutPrimary from '@/mixins/LayoutPrimary'
import ArticlesItemDesktop from '~/components/Page/Articles/ArticlesItemDesktop.vue'
import ArticlesItemMobile from '~/components/Page/Articles/ArticlesItemMobile.vue'
import { getOpenGraphMeta } from '@/helpers/openGraph'

export default {
  name: 'ArticleItemPage',
  mixins: [LayoutPrimary],
  async asyncData(context) {
    try {
      const article = await context.$axios.$get(`/articles/videoconference`)
      return { article }
    } catch (e) {
      context.error({
        statusCode: 404,
        message: 'Axios exception: ' + e.message,
      })
    }
  },
  data() {
    return {
      article: {},
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.pageKeywords,
        },
        ...getOpenGraphMeta({
          title: this.pageTitle,
          description: this.pageDescription,
          path: '/videoconference/',
        }),
      ],
    }
  },
  computed: {
    pageTitle() {
      return this.article.title ? this.article.title : 'Page not found (404)'
    },
    pageDescription() {
      return this.article.description ?? ''
    },
    pageKeywords() {
      return this.article.keywords ?? ''
    },
    pageComponent() {
      return this.$device.isDesktop ? ArticlesItemDesktop : ArticlesItemMobile
    },
  },
}
</script>
